import LoginBtn from "./LoginBtn"
import LogoutBtn from "./LogoutBtn"
import {useAuth0} from "@auth0/auth0-react"

import React from 'react'

export default function LoginButtons() {
    const { isAuthenticated } = useAuth0();

  return (<div className="login-button">
    {
        isAuthenticated ? (
        <>
           <LogoutBtn></LogoutBtn> 
        </>
        ):(
            <>
            <LoginBtn></LoginBtn>
            </>
        )
    }
  </div>
  )
}
